import {useEffect} from 'react';
import {matchPath, useLocation, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {usePiwikContext} from "@utils/tracking/PiwikContext";
import routes from "../../route-config";
import {AppRouteWithTracking} from "@utils/AppConstants";
// const {lng} = useParams<{ lng: string }>();
export default function PiwikPageTracker() {
    const location = useLocation();
    
    const {t} = useTranslation();
    const {setters, trackers} = usePiwikContext();
    const LOCALES = new Set(["en", "pl", "de", "fr", "es", "ru", "it", "tr", "pt"]);
    const trackedRoutes: AppRouteWithTracking[] = routes as any;
    const trackingDict = trackedRoutes.map(r => ({
        // turn "/:lng/orders/edit/:guid?" into "/orders/edit/:guid?"
        pattern: r.path.replace(/^\/:lng(?=\/|$)/, "/"),
        piwikName: r.piwikName,
        titleKey: r.titleKey,
    }));
    const _cache = new Map<string, { piwikName: string; titleKey: string }>();
    function normalize(p: string) {
        return (p.replace(/\/+/g, "/").replace(/\/$/, "") || "/").toLowerCase();
    }
    function resolveFromRest(restPath: string) {
        const p = normalize(restPath);
        const hit = _cache.get(p);
        if (hit) return hit;

        for (const entry of trackingDict) {
            const match = matchPath({ path: entry.pattern, end: true }, p);
            if (match) {
                const titleKey = entry.titleKey
                const res = { piwikName: entry.piwikName, titleKey };
                _cache.set(p, res);
                return res;
            }
        }
        const fallback = { piwikName: `unknown:${p}`, titleKey: "pages.generic" };
        _cache.set(p, fallback);
        return fallback;
    }
    function splitLang(pathname: string, defaultLang = "en") {
        const clean = pathname.replace(/\/+/g, "/").replace(/\/$/, "") || "/";
        const parts = clean.split("/").filter(Boolean);
        const [first, ...restParts] = parts;

        const candidate = first?.toLowerCase();
        const hasLang = candidate && LOCALES.has(candidate);

        const lang = hasLang ? candidate! : defaultLang;
        const rest = `/${(hasLang ? restParts : parts).join("/")}` || "/";

        return {lang, rest};
    }


    function getRouteName(pathWithoutLang: string): string {
        return resolveFromRest(pathWithoutLang).piwikName;
    }

    function getRouteTitleKey(pathWithoutLang: string): string {
        return resolveFromRest(pathWithoutLang).titleKey;
    }

    useEffect(() => {
        // debugger;
        // Get the current route name from the path (or create a mapping)
        const path = location.pathname;
        const pathData = splitLang(path);
        const routeName = getRouteName(pathData.rest);
        const routeTitle = t(getRouteTitleKey(pathData.rest));

        setters.setPiwikScreen("name", routeName);
        setters.setPiwikScreen("title", routeTitle);
        setters.setPiwikScreen("language", pathData.lang);
        //setters.setPiwikScreen("url", path);
        trackers.trackVirtualPageView();
    }, [location.pathname]);

    return null;
}